<template>
  <Tabs :links="tabLinks">
    <div class="white-bg" v-loading="tableLoading">
      <div class="table-heading flex flex-v-center flex-h-bet mb-20">
        <div class="flex">
          <div class="media-group flex filter-label  p-0">
            <div class="filter"><p class="ml-10">Filters:</p></div>
            <el-date-picker
              v-model="filterDate"
              type="date"
              placeholder="Select date(s)"
              class="no-border-date-picker"
              @change="getLogs"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </div>

          <el-select
            v-model="filterStatus"
            placeholder="All Status"
            class="filter-select ml-10"
            clearable
            @change="getLogs"
          >
            <el-option
              v-for="item in clockOptions"
              :key="item.id"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="flex">
          <div class="relative">
            <img
              src="/img/search-icon.svg"
              alt="search team table"
              class="search-icon"
            />
            <el-input
              placeholder="Search"
              name="search"
              type="text"
              class="short mr-10"
              v-model="searchQuery"
              @input="search"
              clearable
            ></el-input>
          </div>
        </div>
      </div>
      <MyLogsTable :data="logs" />
    </div>
  </Tabs>
</template>

<script>
import MyLogsTable from "../components/MyLogsTable.vue";
import Tabs from "@/components/general/Tabs";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers(
  "ess/attendance/mobileClocks"
);
import debounce from "lodash.debounce";
export default {
  data() {
    return {
      clockOptions: [
        {
          id: 1,
          label: "Processing",
          value: "processing",
        },
        {
          id: 2,
          label: "Pending",
          value: "pending",
        },
        {
          id: 3,
          label: "Approved",
          value: "approved",
        },
        {
          id: 4,
          label: "Rejected",
          value: "rejected",
        },
      ],
      tabLinks: [
        {
          label: "Approvals",
          url: "/ess/attendance/mobile-clocks/approvals",
        },
        {
          label: "My Logs",
          url: "/ess/attendance/mobile-clocks/my-logs",
        },
      ],
      settings: "/admin/attendance/mobile-clocks/settings",
    };
  },
  components: {
    MyLogsTable,
    Tabs,
  },
  mounted() {
    this.getLogs();
  },
  computed: {
    ...mapState(["logs", "tableLoading"]),
    searchQuery: {
      set(value) {
        this.$store.commit("ess/attendance/mobileClocks/searchQuery", value);
      },
      get() {
        return this.$store.state.ess.attendance.mobileClocks.searchQuery;
      },
    },
    filterDate: {
      set(value) {
        this.$store.commit("ess/attendance/mobileClocks/filterDate", value);
      },
      get() {
        return this.$store.state.ess.attendance.mobileClocks.filterDate;
      },
    },
    filterStatus: {
      set(value) {
        this.$store.commit("ess/attendance/mobileClocks/filterStatus", value);
      },
      get() {
        return this.$store.state.ess.attendance.mobileClocks.filterStatus;
      },
    },
  },
  methods: {
    ...mapActions(["getLogs"]),
    search: debounce(function() {
      this.getLogs();
    }, 500),
  },
};
</script>
